import {useTranslation} from "react-i18next";
import {useFormContext} from "react-hook-form";
import {Grid, Typography} from "@mui/material";
import {FormAutocomplete, FormCustomSwitch,} from "../../../common/form-fields";
import {FormReportModel} from "../../../api/types/report";
import {SelectElementModelBE, SelectElementModelFE} from "../../../api/types/generic";
import React, { useContext, useEffect, useState } from "react";
import {fromGenericBeToGenericFe} from "../../../utils";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {Location, LocationModelFE} from "../../../api/types/location";
import {useReportsRepository} from "../../../api/repositories/ReportRepository";

const UtilizationAndAvailabilityForm = ({
                                            readOnly,
                                        }: {
    readOnly: boolean;
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    //USE FORM CONTEXT
    const {register, watch, getValues, setValue} = useFormContext<FormReportModel>();

    //USE STATE
    const [location, setLocation] = useState<SelectElementModelFE[]>([]);
    const [dealerOptions, setDealerOptions] = useState<SelectElementModelFE[]>([]);
    const [dealerFilteredOptions, setDealerFilteredOptions] = useState<SelectElementModelFE[]>([]);

    //USE HOOK CUSTOM
    const {getLocationReport} = useReportsRepository();

    // Use Context
    const {
        globalData: {user},
    } = useContext(GlobalContext);

    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name)),
        })
    );

    const optionsFiltered = legalEntityOptions.filter(function (el) {
        return el.code !== "all";
    });

    // Use Query
    // const locationsQuery = useQuery({
    //     queryKey: ["pricing_location_query"],
    //     queryFn: getLocationReport,
    // });
    //
    // const handleGetStaticContent = async () => {
    //     if (locationsQuery?.data) {
    //         const locationsFe: LocationModelFE[] = fromGenericBeToGenericFe<
    //             Location,
    //             LocationModelFE
    //         >(locationsQuery?.data as Location[]).sort(
    //             (a: LocationModelFE, b: LocationModelFE) =>
    //                 a.label.localeCompare(b.label)
    //         );
    //         setLocation(locationsFe);
    //     }
    // };
    //
    // useEffect(() => {
    //     handleGetStaticContent();
    // }, [locationsQuery?.data]);

    const updateDealerSelection = async (value: SelectElementModelFE) => {
        setValue(`legalEntity`, value);
        const location = await getLocationReport(value?.code as string)
        const locationsFe: LocationModelFE[] = fromGenericBeToGenericFe<
            Location,
            LocationModelFE
        >(location as Location[]).sort(
            (a: LocationModelFE, b: LocationModelFE) =>
                a.label.localeCompare(b.label)
        );
        setLocation(locationsFe);
    };

  useEffect(() => {
    if (optionsFiltered.length === 1) {
      updateDealerSelection(optionsFiltered[0]);
    } else {
      let legalEntity = optionsFiltered.find((el) => el.code === watch("legalEntity")?.code);
      if (legalEntity) {
        updateDealerSelection(legalEntity);
      }
    }
    // eslint-disable-next-line
  }, []);

  const renderDealerAndTenant = () => {
    return (
      <>
        <Typography variant="h6" width={"100%"} pl={2} mt={4}
                    hidden={optionsFiltered.length <= 1 || dealerFilteredOptions.length <= 1}>
          {t("pricing:alert.labels.dealerAndTenant")}
        </Typography>
        <Typography variant="h6" width={"100%"} pl={2} mt={4} hidden={optionsFiltered.length <= 1 || dealerFilteredOptions.length > 1}>
          {t("pricing:alert.labels.tenant")}
        </Typography>
        <Typography variant="h6" width={"100%"} pl={2} mt={4} hidden={dealerFilteredOptions.length <= 1 || optionsFiltered.length > 1 }>
          {t("pricing:alert.labels.dealer")}
        </Typography>
        <Grid item xs={12} md={3} hidden={optionsFiltered.length <= 1}>
          <FormAutocomplete
            {...register("legalEntity")}
            label={`${t("pricing:dealer.tenant")}*`}
            //getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.label))}
            options={optionsFiltered || []}
            handleChange={updateDealerSelection}
            isOptionEqualToValue={(
              option: SelectElementModelFE,
              value: SelectElementModelFE
            ) => option.code === value.code}
          />
        </Grid>
        <Grid item xs={12} md={3} hidden={dealerFilteredOptions.length <= 1}>
          <FormAutocomplete
            {...register(`dealer`)}
            label={`${t("pricing:dealer.dealer")}*`}
            options={dealerOptions || []}
            readOnly={Boolean(!watch("legalEntity"))}
            //getOptionLabel={(option: any) => t('translation:dealers.'.concat(option.label))}
            isOptionEqualToValue={(
              option: SelectElementModelFE,
              value: SelectElementModelFE
            ) => option.code === value.code}
          />
        </Grid>
      </>
    );
  };

    return (
        <Grid container columnSpacing={2}>
            <Typography variant="h6" width={"100%"} pl={2} mt={4}>
                {t("pricing:report.labels.searchParameters")}
            </Typography>
            {/*LEGAL ENTITY*/}
          {renderDealerAndTenant()}
            {/*  LOCATIONS */}
            <Grid item xs={12} md={3}>
                <FormAutocomplete
                    {...register("utilizationAndAvailability.location")}
                    label={`${t("pricing:report.labels.locations")}*`}
                    options={location}
                    isOptionEqualToValue={(
                        option: SelectElementModelFE,
                        value: SelectElementModelFE
                    ) => option.code === value.code}
                />
            </Grid>
            {/* MONTH SELECT */}
            <Grid item xs={12} md={3}>
                <FormCustomSwitch
                    {...register("utilizationAndAvailability.currentMonthSelected")}
                    label={
                        watch("utilizationAndAvailability.currentMonthSelected")
                            ? t("pricing:report.labels.currentMonth")
                            : t("pricing:report.labels.nextMonth")
                    }
                    readOnly={false}
                />
            </Grid>
        </Grid>
    );
};

export default UtilizationAndAvailabilityForm;
